import { ForwardedRef, forwardRef, MouseEvent, useState } from 'react';

import { Divider, Icon, IconButton, Popover, PopoverItem } from '@myn/mui';

type Props = {
  onHideActionIcon: () => void;
  onDeleteChat: (e: MouseEvent<HTMLButtonElement>) => void;
  onClickUpdateChatName: (e: MouseEvent<HTMLButtonElement>) => void;
};

const ActionPopover = forwardRef(
  (
    { onHideActionIcon, onDeleteChat, onClickUpdateChatName }: Props,
    ref: ForwardedRef<HTMLButtonElement>,
  ) => {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();

      setAnchorEl(null);
      onHideActionIcon();
    };

    const isOpen = Boolean(anchorEl);

    return (
      <div className="flex flex-col">
        <IconButton
          ref={ref}
          aria-label="Open chat menu"
          icon="OverflowMenuHorizontal"
          variant="icon"
          color="primary"
          onClick={handleClick}
        />
        <Popover
          anchorEl={anchorEl}
          open={isOpen}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <PopoverItem
            text="Rename"
            aria-label="Edit chat"
            startAdornment={<Icon component="Edit" />}
            onItemClick={onClickUpdateChatName}
          />
          <Divider />
          <PopoverItem
            color="red"
            aria-label="Delete chat"
            text="Delete"
            startAdornment={<Icon component="Delete" />}
            onItemClick={onDeleteChat}
          />
        </Popover>
      </div>
    );
  },
);

export default ActionPopover;
